exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-toolbar mat-chip-list {\n  margin-left: 20px; }\n\n.product-images .product-image {\n  display: inline-block; }\n\n.product-images img {\n  max-width: 200px; }\n\nimg.qr {\n  max-width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ProductsModule/ProductDetailComponent/product-detail.component.scss
// module id = ../../../../../src/ProductsModule/ProductDetailComponent/product-detail.component.scss
// module chunks = main